import { Translate } from 'next-translate'

import { BenefitTileProps } from '../common/BenefitTile'

export const getList = (t: Translate): BenefitTileProps[] => {
  const contentTags = [
    'creators_economy',
    'content_marketing',
    'well_being',
    'social_media_and_adds',
  ]
  return contentTags.map((item) => ({
    imageKey: item,
    title: t(`${item}`),
    description: t(`${item}_desc`),
  }))
}

export const getStats = (t: Translate) => [
  { statistic: '2500', description: t('realized_campaigns') },
  { statistic: '1000', description: t('brands') },
  { statistic: '50000', description: t('creators') },
]
